import { useDispatch } from 'react-redux';
import { Dispatch, useCallback } from 'react';
import { useHistory } from 'react-router';

import { Layout } from '../../../CorePackage/MainModule/components/Layout';
import { PassportGroupTypeEnum } from '../../../APIPackage/PassportGroupsModule/enums/PassportGroupTypeEnum';
import { PassportGroupForm } from '../../../PassportGroupPackage/PassportGroupFormModule/components/PassportGroupForm';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { passportGroupSetNoticeAction } from '../../../PassportGroupPackage/MainModule/actions/passportGroupActions';
import { ROUTE_KNM_MASS_DELETION } from '../../../CorePackage/MainModule/routes/routes';

export const PassportMassDeletionCreateGroupPage = () => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const history = useHistory();
  const handleGroupCreated = useCallback(() => {
    dispatch(passportGroupSetNoticeAction('Группа успешно создана. Запущен фоновый процесс сбора паспортов группы.'));
    history.push(ROUTE_KNM_MASS_DELETION);
  }, [history, dispatch]);

  const handleCancelCreate = useCallback(() => {
    history.push(ROUTE_KNM_MASS_DELETION);
  }, [history]);

  return (
    <Layout withFooter>
      <PassportGroupForm
        onGroupCreated={handleGroupCreated}
        onCancelCreate={handleCancelCreate}
        groupType={PassportGroupTypeEnum.DELETION}
      />
    </Layout>
  );
};
